// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@400;500;600&family=Inter:wght@400;500;600&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*:where(*) {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

:root {
  --bg: #050304;
  --bg-soft: rgba(255, 255, 255, 0.04);
  --surface: rgba(255, 255, 255, 0.08);
  --card: rgba(255, 255, 255, 0.12);
  --text: #f5f5f5;
  --muted: #b5b5c7;
  --orange: #ff6b2c;
  --orange-dark: #ff4b00;
  --accent: linear-gradient(120deg, #ff7b39, #ff4b00);
  --radius: 20px;
  --shadow: 0 20px 60px rgba(0, 0, 0, 0.35);
  --font-display: "Space Grotesk", "Inter", system-ui, -apple-system, sans-serif;
  --font-body: "Inter", system-ui, -apple-system, sans-serif;
}

body {
  font-family: var(--font-body);
  background: var(--bg);
  color: var(--text);
  line-height: 1.55;
  -webkit-font-smoothing: antialiased;
}

img {
  max-width: 100%;
  display: block;
}

a {
  color: inherit;
  text-decoration: none;
}

.container {
  width: min(1200px, 90vw);
  margin: 0 auto;
}

.site-header {
  position: sticky;
  top: 0;
  z-index: 10;
  background: rgba(5, 3, 4, 0.85);
  backdrop-filter: blur(16px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
}

.nav-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 24px 0;
  gap: 24px;
}

.brand {
  display: flex;
  align-items: center;
  gap: 12px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.brand img {
  height: 32px;
  width: auto;
}

.desktop-nav {
  display: flex;
  gap: 28px;
  font-size: 0.95rem;
  color: var(--muted);
}

.desktop-nav a:hover {
  color: var(--text);
}

.nav-cta {
  display: flex;
  align-items: center;
  gap: 20px;
}

.text-link {
  color: var(--muted);
}

.text-link:hover {
  color: var(--text);
}

.primary-btn,
.outline-btn,
.ghost-btn {
  border: none;
  padding: 12px 22px;
  border-radius: 999px;
  font-weight: 600;
  cursor: pointer;
  transition: transform 200ms ease, box-shadow 200ms ease, background 200ms ease;
}

.primary-btn {
  background: var(--accent);
  color: var(--text);
  box-shadow: 0 8px 18px rgba(255, 107, 44, 0.35);
}

.primary-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 24px rgba(255, 107, 44, 0.4);
}

.outline-btn {
  border: 1px solid rgba(255, 255, 255, 0.3);
  background: transparent;
  color: var(--text);
}

.outline-btn:hover {
  border-color: #fff;
}

.ghost-btn {
  background: rgba(255, 255, 255, 0.06);
  color: var(--text);
}

.ghost-btn:hover {
  background: rgba(255, 255, 255, 0.12);
}

.nav-toggle {
  width: 44px;
  height: 44px;
  display: none;
  position: relative;
}

.nav-toggle::before,
.nav-toggle::after {
  content: "";
  position: absolute;
  left: 12px;
  right: 12px;
  height: 2px;
  background: var(--text);
  transition: transform 200ms ease;
}

.nav-toggle::before {
  top: 16px;
}

.nav-toggle::after {
  bottom: 16px;
}

.nav-toggle.active::before {
  transform: translateY(6px) rotate(45deg);
}

.nav-toggle.active::after {
  transform: translateY(-6px) rotate(-45deg);
}

.mobile-drawer {
  display: none;
  flex-direction: column;
  gap: 16px;
  padding: 0 20px 20px;
  background: rgba(5, 3, 4, 0.95);
}

.mobile-drawer.open {
  display: flex;
}

.hero {
  padding: 120px 0 60px;
  background: radial-gradient(circle at top, rgba(255, 107, 44, 0.15), transparent);
  height: calc(100dvh - 100px);
}

.hero-copy {
  display: flex;
  flex-direction: column;
  gap: 50px;
}

.hero-grid {
  display: flex;
  gap: 48px;
  align-items: center;
}

.hero-copy h1 {
  font-family: var(--font-display);
  font-size: clamp(2.6rem, 5vw, 4rem);
  letter-spacing: -0.04em;
  margin-bottom: 18px;
}

.eyebrow,
.section-label {
  font-size: 0.9rem;
  text-transform: uppercase;
  letter-spacing: 0.25em;
  color: var(--muted);
  margin-bottom: 18px;
}

.lede {
  font-size: 1.15rem;
  color: var(--muted);
  margin-bottom: 24px;
}

.hero-cta {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 32px;
}

.hero-metrics {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 18px;
}

.metric {
  font-size: 1.9rem;
  font-weight: 600;
  color: var(--text);
}

.hero-media {
  position: relative;
  display: flex;
  justify-content: center;
}

.device-frame {
  background: var(--surface);
  border-radius: 32px;
  padding: 24px;
  width: 100%;
  max-width: 500px;
  margin: 0 auto;
  position: relative;
  box-shadow: var(--shadow);
  transform: translateY(30px);
  opacity: 0;
  transition: transform 600ms ease, opacity 600ms ease;
}

.device-img {
  border-radius: 24px;
}

.floating-card {
  position: absolute;
  right: -30px;
  bottom: 20px;
  background: rgba(5, 3, 4, 0.9);
  border-radius: var(--radius);
  padding: 16px 18px;
  width: 240px;
  box-shadow: var(--shadow);
}

.floating-card.secondary {
  top: 20px;
  left: -30px;
  right: auto;
}

.card-title {
  font-weight: 600;
  margin-bottom: 6px;
}

.card-body {
  color: var(--muted);
  font-size: 0.9rem;
}

.partners {
  padding-top: 100px;
  padding-bottom: 50px;
  border-top: 1px solid rgba(255, 255, 255, 0.05);
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  overflow: hidden;
}

.marquee {
  text-align: center;
  color: var(--muted);
}

.logo-marquee {
  margin-top: 32px;
  overflow: hidden;
  position: relative;
  width: 100vw;
  margin-left: calc(-50vw + 50%);
}

.logo-marquee > div {
  display: flex;
  gap: 24px;
  width: fit-content;
  animation: scroll-left 40s linear infinite;
}

.logo-row {
  display: flex;
  gap: 100px;
  padding-right: 100px;
  flex-shrink: 0;
}

@keyframes scroll-left {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(calc(-50% - 12px));
  }
}
.compliance-logo {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 16px 22px;
  border-radius: var(--radius);
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(255, 255, 255, 0.03);
  color: var(--text);
}

.compliance-logo img {
  height: 42px;
  object-fit: contain;
  opacity: 0.95;
}

.compliance-logo span {
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  font-size: 0.8rem;
  color: var(--muted);
}

.how {
  padding: 100px 0;
}

.two-col {
  display: grid;
  grid-template-columns: 220px 1fr;
  gap: 32px;
}

.how-content {
  display: grid;
  gap: 24px;
}

.how article {
  background: var(--surface);
  padding: 24px;
  border-radius: var(--radius);
  border: 1px solid rgba(255, 255, 255, 0.05);
}

.features {
  padding: 100px 0;
  background: rgba(255, 255, 255, 0.02);
}

.section-heading {
  margin-bottom: 48px;
  max-width: 720px;
}

.section-heading h2 {
  font-family: var(--font-display);
  font-size: clamp(2rem, 4vw, 3rem);
  line-height: 1.2;
}

.feature-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 24px;
}

.feature-grid article {
  background: var(--surface);
  padding: 24px;
  border-radius: var(--radius);
  display: flex;
  flex-direction: column;
  gap: 16px;
  border: 1px solid rgba(255, 255, 255, 0.05);
  transform: translateY(30px);
  opacity: 0;
  transition: transform 500ms ease, opacity 500ms ease;
}

.feature-grid article.in-view,
.device-frame.in-view {
  transform: translateY(0);
  opacity: 1;
}

.feature-grid img {
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.08);
}

.tag {
  display: inline-flex;
  align-self: flex-start;
  font-size: 0.78rem;
  text-transform: uppercase;
  letter-spacing: 0.2em;
  padding: 6px 14px;
  border-radius: 999px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: var(--muted);
}

.collab {
  padding: 90px 0;
}

.collab-inner {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 32px;
  background: var(--surface);
  border-radius: var(--radius);
  padding: 40px;
  border: 1px solid rgba(255, 255, 255, 0.05);
}

.pill-group {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.pill {
  padding: 10px 16px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.05);
  font-size: 0.9rem;
}

.testimonials {
  padding: 100px 0;
}

.testimonial-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 24px;
}

.testimonial-grid article {
  background: var(--surface);
  padding: 28px;
  border-radius: var(--radius);
  border: 1px solid rgba(255, 255, 255, 0.05);
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.testimonial-grid strong {
  display: block;
  font-size: 1rem;
}

.testimonial-grid span {
  color: var(--muted);
  font-size: 0.9rem;
}

.pricing {
  padding: 100px 0;
  background: rgba(255, 255, 255, 0.02);
}

.pricing-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 48px;
  align-items: stretch;
}

.pricing-intro h2 {
  margin-bottom: 16px;
}

.pricing-lede {
  color: var(--muted);
  font-size: 1.1rem;
  margin-bottom: 32px;
}

.pricing-perks {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  gap: 16px;
}

.pricing-perks div {
  background: var(--surface);
  border-radius: var(--radius);
  border: 1px solid rgba(255, 255, 255, 0.06);
  padding: 18px;
}

.pricing-perks p {
  color: var(--muted);
  margin-top: 6px;
}

.pricing-card {
  background: linear-gradient(140deg, rgba(255, 107, 44, 0.18), rgba(5, 3, 4, 0.8));
  border-radius: calc(var(--radius) + 4px);
  padding: 40px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  display: flex;
  flex-direction: column;
  gap: 20px;
  box-shadow: 0 25px 60px rgba(0, 0, 0, 0.35);
}

.pricing-badge {
  align-self: flex-start;
  background: rgba(5, 3, 4, 0.5);
  border: 1px solid rgba(255, 255, 255, 0.15);
  padding: 6px 14px;
  border-radius: 999px;
  font-size: 0.85rem;
  letter-spacing: 0.1em;
  text-transform: uppercase;
}

.pricing-price {
  display: flex;
  align-items: baseline;
  gap: 10px;
}

.pricing-price span:first-child {
  font-size: clamp(3rem, 6vw, 3.8rem);
  font-family: var(--font-display);
  font-weight: 600;
}

.pricing-price span:last-child {
  color: var(--muted);
  font-size: 1rem;
}

.pricing-card > p {
  color: var(--muted);
}

.pricing-features {
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin: 0;
  padding: 0;
}

.pricing-features li {
  position: relative;
  padding-left: 28px;
  color: var(--text);
}

.pricing-features li::before {
  content: "";
  position: absolute;
  left: 0;
  top: 8px;
  width: 14px;
  height: 14px;
  border-radius: 4px;
  background: var(--accent);
  box-shadow: 0 0 10px rgba(255, 107, 44, 0.5);
}

.pricing-card .primary-btn {
  width: 100%;
  text-align: center;
}

.pricing-note {
  color: var(--muted);
  font-size: 0.95rem;
  text-align: center;
}

.faq {
  padding: 100px 0 120px;
}

.faq-list {
  display: grid;
  gap: 16px;
}

.faq-item {
  border-radius: var(--radius);
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: var(--surface);
}

.faq-item button {
  width: 100%;
  background: none;
  border: none;
  color: var(--text);
  font-size: 1.1rem;
  padding: 20px 24px;
  text-align: left;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
}

.faq-item span {
  width: 16px;
  height: 16px;
  position: relative;
  display: inline-block;
}

.faq-item span::before,
.faq-item span::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: var(--text);
}

.faq-item span::before {
  width: 12px;
  height: 2px;
}

.faq-item span::after {
  width: 2px;
  height: 12px;
}

.faq-item button[aria-expanded=true] span::after {
  opacity: 0;
}

.faq-content {
  max-height: 0;
  overflow: hidden;
  padding: 0 24px;
  color: var(--muted);
  opacity: 0;
  transition: max-height 300ms ease, padding 300ms ease, opacity 300ms ease;
}

.faq-item.open .faq-content {
  max-height: 320px;
  padding: 12px 24px 20px;
  opacity: 1;
}

.cta {
  padding: 100px 0;
  background: radial-gradient(circle at top, rgba(255, 107, 44, 0.3), transparent);
}

.cta-inner {
  background: var(--surface);
  border-radius: var(--radius);
  padding: 48px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 32px;
  border: 1px solid rgba(255, 255, 255, 0.05);
}

.title-h1 {
  line-height: 1.1;
}

.cta-downloads {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
}

.store-card {
  flex: 1 1 240px;
  min-width: 220px;
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 18px 26px;
  border-radius: 26px;
  background: #fff;
  color: #111;
  box-shadow: 0 12px 25px rgba(0, 0, 0, 0.2);
  transition: transform 200ms ease, box-shadow 200ms ease;
  height: fit-content;
  max-height: fit-content;
}

.store-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 18px 30px rgba(0, 0, 0, 0.25);
}

.store-icon {
  width: 48px;
  height: 48px;
  border-radius: 16px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.05);
  color: #111;
}

.store-icon svg {
  width: 26px;
  height: 26px;
  fill: currentColor;
}

.store-copy {
  display: flex;
  flex-direction: column;
  line-height: 1.1;
}

.store-label {
  font-size: 0.9rem;
  color: #555;
}

.store-name {
  font-size: 1.35rem;
  font-weight: 600;
}

.store-apple .store-icon {
  background: #111;
  color: #fff;
}

.store-play .store-icon {
  background: #111;
  color: #0f9d58;
}

.store-windows .store-icon {
  background: #e3f0ff;
  color: #0078d4;
}

.store-macos .store-icon {
  background: #f0ecff;
  color: #5337ff;
}

.cta-form {
  display: grid;
  gap: 16px;
}

.cta-form input {
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 999px;
  padding: 14px 20px;
  background: rgba(5, 3, 4, 0.6);
  color: var(--text);
  font-size: 1rem;
}

.site-footer {
  padding: 80px 0 60px;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
}

.footer-top {
  display: flex;
  flex-wrap: wrap;
  gap: 48px;
  justify-content: space-between;
  align-items: flex-start;
}

.footer-brand {
  max-width: 320px;
}

.brand-footer img {
  height: 32px;
}

.footer-brand p {
  margin-top: 16px;
  color: var(--muted);
}

.footer-links-grid {
  flex: 1;
  min-width: 320px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 32px 48px;
}

.footer-column p {
  font-weight: 600;
  margin-bottom: 16px;
}

.footer-column > a {
  display: block;
  margin-bottom: 10px;
  color: var(--muted);
  transition: color 200ms ease;
}

.footer-column > a:hover {
  color: var(--text);
}

.footer-socials {
  display: flex;
  gap: 12px;
  justify-content: flex-start;
}

.social-btn {
  width: 44px;
  height: 44px;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.08);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 200ms ease, background 200ms ease;
}

.social-btn svg {
  width: 20px;
  height: 20px;
  fill: #fff;
}

.social-btn:hover {
  transform: translateY(-2px);
  background: rgba(255, 255, 255, 0.15);
}

.footer-divider {
  height: 1px;
  background: rgba(255, 255, 255, 0.1);
  margin: 48px 0 28px;
}

.footer-bottom {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.footer-copy {
  color: var(--muted);
}

.footer-legal {
  display: flex;
  gap: 24px;
  color: var(--muted);
}

.footer-legal a:hover {
  color: var(--text);
}

@media (max-width: 900px) {
  .desktop-nav {
    display: none;
  }
  .nav-toggle {
    display: block;
  }
  .nav-cta .text-link {
    display: none;
  }
  .two-col {
    grid-template-columns: 1fr;
  }
  .hero-metrics {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .hero-grid {
    flex-direction: column;
    text-align: center;
    align-items: center;
  }
  .hero-copy {
    align-items: center;
  }
  .hero-media {
    justify-content: center;
  }
}
@media (max-width: 640px) {
  .hero-metrics {
    grid-template-columns: 1fr;
  }
  .cta-inner {
    padding: 32px;
  }
  .cta-downloads {
    flex-direction: column;
  }
  .nav-container {
    padding: 18px 0;
  }
  .footer-links-grid {
    grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  }
  .footer-bottom {
    flex-direction: column;
    align-items: flex-start;
  }
  .footer-legal {
    flex-wrap: wrap;
    gap: 12px;
  }
  .hero {
    padding: 90px 0 40px;
    height: auto;
  }
  .hero-grid {
    gap: 32px;
  }
  .hero-copy {
    text-align: center;
    gap: 24px;
  }
  .hero-cta {
    justify-content: center;
  }
  .hero-media {
    width: 100%;
  }
  .device-frame {
    max-width: 360px;
    padding: 18px;
  }
  .logo-marquee {
    width: 100%;
    margin-left: 0;
  }
  .logo-row {
    gap: 32px;
    padding-right: 32px;
  }
  .collab-inner,
  .section-heading,
  .pricing-intro,
  .pricing-card,
  .cta-inner,
  .testimonial-grid article {
    text-align: center;
  }
  .pill-group {
    justify-content: center;
  }
  .cta-downloads {
    width: 100%;
  }
  .store-card {
    width: 100%;
    justify-content: center;
  }
  .footer-top {
    flex-direction: column;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/css/dark.scss"],"names":[],"mappings":"AAEA;EACE,SAAA;EACA,UAAA;EACA,sBAAA;AAAF;;AAGA;EACE,aAAA;EACA,oCAAA;EACA,oCAAA;EACA,iCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,mDAAA;EACA,cAAA;EACA,yCAAA;EACA,8EAAA;EACA,0DAAA;AAAF;;AAGA;EACE,6BAAA;EACA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,mCAAA;AAAF;;AAGA;EACE,eAAA;EACA,cAAA;AAAF;;AAGA;EACE,cAAA;EACA,qBAAA;AAAF;;AAGA;EACE,wBAAA;EACA,cAAA;AAAF;;AAGA;EACE,gBAAA;EACA,MAAA;EACA,WAAA;EACA,+BAAA;EACA,2BAAA;EACA,kDAAA;AAAF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,SAAA;AAAF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;AAAF;;AAGA;EACE,YAAA;EACA,WAAA;AAAF;;AAGA;EACE,aAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;;;EAGE,YAAA;EACA,kBAAA;EACA,oBAAA;EACA,gBAAA;EACA,eAAA;EACA,8EAAA;AAAF;;AAGA;EACE,yBAAA;EACA,kBAAA;EACA,+CAAA;AAAF;;AAGA;EACE,2BAAA;EACA,+CAAA;AAAF;;AAGA;EACE,0CAAA;EACA,uBAAA;EACA,kBAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,qCAAA;EACA,kBAAA;AAAF;;AAGA;EACE,qCAAA;AAAF;;AAGA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;AAAF;;AAGA;;EAEE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,WAAA;EACA,uBAAA;EACA,gCAAA;AAAF;;AAGA;EACE,SAAA;AAAF;;AAGA;EACE,YAAA;AAAF;;AAGA;EACE,wCAAA;AAAF;;AAGA;EACE,0CAAA;AAAF;;AAGA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,oBAAA;EACA,+BAAA;AAAF;;AAGA;EACE,aAAA;AAAF;;AAGA;EACE,qBAAA;EACA,iFAAA;EACA,4BAAA;AAAF;;AAGA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAAF;;AAGA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;AAAF;;AAGA;EACE,gCAAA;EACA,mCAAA;EACA,uBAAA;EACA,mBAAA;AAAF;;AAGA;;EAEE,iBAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;EACA,mBAAA;AAAF;;AAGA;EACE,kBAAA;EACA,mBAAA;EACA,mBAAA;AAAF;;AAGA;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,mBAAA;AAAF;;AAGA;EACE,aAAA;EACA,gDAAA;EACA,SAAA;AAAF;;AAGA;EACE,iBAAA;EACA,gBAAA;EACA,kBAAA;AAAF;;AAGA;EACE,kBAAA;EACA,aAAA;EACA,uBAAA;AAAF;;AAGA;EACE,0BAAA;EACA,mBAAA;EACA,aAAA;EACA,WAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,yBAAA;EACA,2BAAA;EACA,UAAA;EACA,oDAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,kBAAA;EACA,YAAA;EACA,YAAA;EACA,8BAAA;EACA,4BAAA;EACA,kBAAA;EACA,YAAA;EACA,yBAAA;AAAF;;AAGA;EACE,SAAA;EACA,WAAA;EACA,WAAA;AAAF;;AAGA;EACE,gBAAA;EACA,kBAAA;AAAF;;AAGA;EACE,mBAAA;EACA,iBAAA;AAAF;;AAGA;EACE,kBAAA;EACA,oBAAA;EACA,+CAAA;EACA,kDAAA;EACF,gBAAA;AAAA;;AAGA;EACE,kBAAA;EACA,mBAAA;AAAF;;AAIA;EACE,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,8BAAA;AADF;;AAIA;EACE,aAAA;EACA,SAAA;EACA,kBAAA;EACA,0CAAA;AADF;;AAIA;EACE,aAAA;EACA,UAAA;EACA,oBAAA;EACA,cAAA;AADF;;AAIA;EACE;IACE,wBAAA;EADF;EAGA;IACE,wCAAA;EADF;AACF;AAIA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,4BAAA;EACA,0CAAA;EACA,qCAAA;EACA,kBAAA;AAFF;;AAKA;EACE,YAAA;EACA,mBAAA;EACA,aAAA;AAFF;;AAKA;EACE,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,iBAAA;EACA,mBAAA;AAFF;;AAKA;EACE,gBAAA;AAFF;;AAKA;EACE,aAAA;EACA,gCAAA;EACA,SAAA;AAFF;;AAKA;EACE,aAAA;EACA,SAAA;AAFF;;AAKA;EACE,0BAAA;EACA,aAAA;EACA,4BAAA;EACA,2CAAA;AAFF;;AAKA;EACE,gBAAA;EACA,qCAAA;AAFF;;AAKA;EACE,mBAAA;EACA,gBAAA;AAFF;;AAKA;EACE,gCAAA;EACA,iCAAA;EACA,gBAAA;AAFF;;AAKA;EACE,aAAA;EACA,2DAAA;EACA,SAAA;AAFF;;AAKA;EACE,0BAAA;EACA,aAAA;EACA,4BAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,2CAAA;EACA,2BAAA;EACA,UAAA;EACA,oDAAA;AAFF;;AAKA;;EAEE,wBAAA;EACA,UAAA;AAFF;;AAKA;EACE,mBAAA;EACA,2CAAA;AAFF;;AAKA;EACE,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,yBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,0CAAA;EACA,mBAAA;AAFF;;AAKA;EACE,eAAA;AAFF;;AAKA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,SAAA;EACA,0BAAA;EACA,4BAAA;EACA,aAAA;EACA,2CAAA;AAFF;;AAKA;EACE,aAAA;EACA,eAAA;EACA,SAAA;AAFF;;AAKA;EACE,kBAAA;EACA,oBAAA;EACA,qCAAA;EACA,2CAAA;EACA,iBAAA;AAFF;;AAKA;EACE,gBAAA;AAFF;;AAKA;EACE,aAAA;EACA,2DAAA;EACA,SAAA;AAFF;;AAKA;EACE,0BAAA;EACA,aAAA;EACA,4BAAA;EACA,2CAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAFF;;AAKA;EACE,cAAA;EACA,eAAA;AAFF;;AAKA;EACE,mBAAA;EACA,iBAAA;AAFF;;AAKA;EACE,gBAAA;EACA,qCAAA;AAFF;;AAKA;EACE,aAAA;EACA,2DAAA;EACA,SAAA;EACA,oBAAA;AAFF;;AAKA;EACE,mBAAA;AAFF;;AAKA;EACE,mBAAA;EACA,iBAAA;EACA,mBAAA;AAFF;;AAKA;EACE,aAAA;EACA,2DAAA;EACA,SAAA;AAFF;;AAKA;EACE,0BAAA;EACA,4BAAA;EACA,2CAAA;EACA,aAAA;AAFF;;AAKA;EACE,mBAAA;EACA,eAAA;AAFF;;AAKA;EACE,iFAAA;EACA,wCAAA;EACA,aAAA;EACA,2CAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,2CAAA;AAFF;;AAKA;EACE,sBAAA;EACA,8BAAA;EACA,2CAAA;EACA,iBAAA;EACA,oBAAA;EACA,kBAAA;EACA,qBAAA;EACA,yBAAA;AAFF;;AAKA;EACE,aAAA;EACA,qBAAA;EACA,SAAA;AAFF;;AAKA;EACE,mCAAA;EACA,gCAAA;EACA,gBAAA;AAFF;;AAKA;EACE,mBAAA;EACA,eAAA;AAFF;;AAKA;EACE,mBAAA;AAFF;;AAKA;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,SAAA;EACA,UAAA;AAFF;;AAKA;EACE,kBAAA;EACA,kBAAA;EACA,kBAAA;AAFF;;AAKA;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,4CAAA;AAFF;;AAKA;EACE,WAAA;EACA,kBAAA;AAFF;;AAKA;EACE,mBAAA;EACA,kBAAA;EACA,kBAAA;AAFF;;AAKA;EACE,sBAAA;AAFF;;AAKA;EACE,aAAA;EACA,SAAA;AAFF;;AAKA;EACE,4BAAA;EACA,2CAAA;EACA,0BAAA;AAFF;;AAKA;EACE,WAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;AAFF;;AAKA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,qBAAA;AAFF;;AAKA;;EAEE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,uBAAA;AAFF;;AAKA;EACE,WAAA;EACA,WAAA;AAFF;;AAKA;EACE,UAAA;EACA,YAAA;AAFF;;AAKA;EACE,UAAA;AAFF;;AAKA;EACE,aAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,UAAA;EACA,yEAAA;AAFF;;AAKA;EACE,iBAAA;EACA,uBAAA;EACA,UAAA;AAFF;;AAKA;EACE,gBAAA;EACA,gFAAA;AAFF;;AAKA;EACE,0BAAA;EACA,4BAAA;EACA,aAAA;EACA,aAAA;EACA,2DAAA;EACA,SAAA;EACA,2CAAA;AAFF;;AAKA;EACE,gBAAA;AAFF;;AAKA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,SAAA;AAFF;;AAKA;EACE,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,0CAAA;EACA,uDAAA;EACA,mBAAA;EACA,uBAAA;AAFF;;AAKA;EACE,2BAAA;EACA,2CAAA;AAFF;;AAKA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,+BAAA;EACA,WAAA;AAFF;;AAKA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AAFF;;AAKA;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;AAFF;;AAKA;EACE,iBAAA;EACA,WAAA;AAFF;;AAKA;EACE,kBAAA;EACA,gBAAA;AAFF;;AAKA;EACE,gBAAA;EACA,WAAA;AAFF;;AAKA;EACE,gBAAA;EACA,cAAA;AAFF;;AAKA;EACE,mBAAA;EACA,cAAA;AAFF;;AAKA;EACE,mBAAA;EACA,cAAA;AAFF;;AAKA;EACE,aAAA;EACA,SAAA;AAFF;;AAKA;EACE,2CAAA;EACA,oBAAA;EACA,kBAAA;EACA,8BAAA;EACA,kBAAA;EACA,eAAA;AAFF;;AAKA;EACE,oBAAA;EACA,+CAAA;AAFF;;AAKA;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,8BAAA;EACA,uBAAA;AAFF;;AAKA;EACE,gBAAA;AAFF;;AAKA;EACE,YAAA;AAFF;;AAKA;EACE,gBAAA;EACA,mBAAA;AAFF;;AAKA;EACE,OAAA;EACA,gBAAA;EACA,aAAA;EACA,2DAAA;EACA,cAAA;AAFF;;AAKA;EACE,gBAAA;EACA,mBAAA;AAFF;;AAKA;EACE,cAAA;EACA,mBAAA;EACA,mBAAA;EACA,4BAAA;AAFF;;AAKA;EACE,kBAAA;AAFF;;AAKA;EACE,aAAA;EACA,SAAA;EACA,2BAAA;AAFF;;AAKA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,qCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,uDAAA;AAFF;;AAKA;EACE,WAAA;EACA,YAAA;EACA,UAAA;AAFF;;AAKA;EACE,2BAAA;EACA,qCAAA;AAFF;;AAKA;EACE,WAAA;EACA,oCAAA;EACA,mBAAA;AAFF;;AAKA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;AAFF;;AAKA;EACE,mBAAA;AAFF;;AAKA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;AAFF;;AAKA;EACE,kBAAA;AAFF;;AAKA;EACE;IACE,aAAA;EAFF;EAKA;IACE,cAAA;EAHF;EAMA;IACE,aAAA;EAJF;EAOA;IACE,0BAAA;EALF;EAQA;IACE,gDAAA;EANF;EASA;IACE,sBAAA;IACA,kBAAA;IACA,mBAAA;EAPF;EAUA;IACE,mBAAA;EARF;EAWA;IACE,uBAAA;EATF;AACF;AAYA;EACE;IACE,0BAAA;EAVF;EAaA;IACE,aAAA;EAXF;EAcA;IACE,sBAAA;EAZF;EAeA;IACE,eAAA;EAbF;EAgBA;IACE,2DAAA;EAdF;EAiBA;IACE,sBAAA;IACA,uBAAA;EAfF;EAkBA;IACE,eAAA;IACA,SAAA;EAhBF;EAmBA;IACE,oBAAA;IACA,YAAA;EAjBF;EAoBA;IACE,SAAA;EAlBF;EAqBA;IACE,kBAAA;IACA,SAAA;EAnBF;EAsBA;IACE,uBAAA;EApBF;EAuBA;IACE,WAAA;EArBF;EAwBA;IACE,gBAAA;IACA,aAAA;EAtBF;EAyBA;IACE,WAAA;IACA,cAAA;EAvBF;EA0BA;IACE,SAAA;IACA,mBAAA;EAxBF;EA2BA;;;;;;IAME,kBAAA;EAzBF;EA4BA;IACE,uBAAA;EA1BF;EA6BA;IACE,WAAA;EA3BF;EA8BA;IACE,WAAA;IACA,uBAAA;EA5BF;EA+BA;IACE,sBAAA;EA7BF;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@400;500;600&family=Inter:wght@400;500;600&display=swap');\n\n*:where(*) {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n:root {\n  --bg: #050304;\n  --bg-soft: rgba(255, 255, 255, 0.04);\n  --surface: rgba(255, 255, 255, 0.08);\n  --card: rgba(255, 255, 255, 0.12);\n  --text: #f5f5f5;\n  --muted: #b5b5c7;\n  --orange: #ff6b2c;\n  --orange-dark: #ff4b00;\n  --accent: linear-gradient(120deg, #ff7b39, #ff4b00);\n  --radius: 20px;\n  --shadow: 0 20px 60px rgba(0, 0, 0, 0.35);\n  --font-display: \"Space Grotesk\", \"Inter\", system-ui, -apple-system, sans-serif;\n  --font-body: \"Inter\", system-ui, -apple-system, sans-serif;\n}\n\nbody {\n  font-family: var(--font-body);\n  background: var(--bg);\n  color: var(--text);\n  line-height: 1.55;\n  -webkit-font-smoothing: antialiased;\n}\n\nimg {\n  max-width: 100%;\n  display: block;\n}\n\na {\n  color: inherit;\n  text-decoration: none;\n}\n\n.container {\n  width: min(1200px, 90vw);\n  margin: 0 auto;\n}\n\n.site-header {\n  position: sticky;\n  top: 0;\n  z-index: 10;\n  background: rgba(5, 3, 4, 0.85);\n  backdrop-filter: blur(16px);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.05);\n}\n\n.nav-container {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 24px 0;\n  gap: 24px;\n}\n\n.brand {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  font-weight: 600;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n\n.brand img {\n  height: 32px;\n  width: auto;\n}\n\n.desktop-nav {\n  display: flex;\n  gap: 28px;\n  font-size: 0.95rem;\n  color: var(--muted);\n}\n\n.desktop-nav a:hover {\n  color: var(--text);\n}\n\n.nav-cta {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n}\n\n.text-link {\n  color: var(--muted);\n}\n\n.text-link:hover {\n  color: var(--text);\n}\n\n.primary-btn,\n.outline-btn,\n.ghost-btn {\n  border: none;\n  padding: 12px 22px;\n  border-radius: 999px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: transform 200ms ease, box-shadow 200ms ease, background 200ms ease;\n}\n\n.primary-btn {\n  background: var(--accent);\n  color: var(--text);\n  box-shadow: 0 8px 18px rgba(255, 107, 44, 0.35);\n}\n\n.primary-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 12px 24px rgba(255, 107, 44, 0.4);\n}\n\n.outline-btn {\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  background: transparent;\n  color: var(--text);\n}\n\n.outline-btn:hover {\n  border-color: #fff;\n}\n\n.ghost-btn {\n  background: rgba(255, 255, 255, 0.06);\n  color: var(--text);\n}\n\n.ghost-btn:hover {\n  background: rgba(255, 255, 255, 0.12);\n}\n\n.nav-toggle {\n  width: 44px;\n  height: 44px;\n  display: none;\n  position: relative;\n}\n\n.nav-toggle::before,\n.nav-toggle::after {\n  content: \"\";\n  position: absolute;\n  left: 12px;\n  right: 12px;\n  height: 2px;\n  background: var(--text);\n  transition: transform 200ms ease;\n}\n\n.nav-toggle::before {\n  top: 16px;\n}\n\n.nav-toggle::after {\n  bottom: 16px;\n}\n\n.nav-toggle.active::before {\n  transform: translateY(6px) rotate(45deg);\n}\n\n.nav-toggle.active::after {\n  transform: translateY(-6px) rotate(-45deg);\n}\n\n.mobile-drawer {\n  display: none;\n  flex-direction: column;\n  gap: 16px;\n  padding: 0 20px 20px;\n  background: rgba(5, 3, 4, 0.95);\n}\n\n.mobile-drawer.open {\n  display: flex;\n}\n\n.hero {\n  padding: 120px 0 60px;\n  background: radial-gradient(circle at top, rgba(255, 107, 44, 0.15), transparent);\n  height: calc(100dvh - 100px);\n}\n\n.hero-copy{\n  display: flex;\n  flex-direction: column;\n  gap: 50px;\n}\n\n.hero-grid {\n  display: flex;\n  gap: 48px;\n  align-items: center;\n}\n\n.hero-copy h1 {\n  font-family: var(--font-display);\n  font-size: clamp(2.6rem, 5vw, 4rem);\n  letter-spacing: -0.04em;\n  margin-bottom: 18px;\n}\n\n.eyebrow,\n.section-label {\n  font-size: 0.9rem;\n  text-transform: uppercase;\n  letter-spacing: 0.25em;\n  color: var(--muted);\n  margin-bottom: 18px;\n}\n\n.lede {\n  font-size: 1.15rem;\n  color: var(--muted);\n  margin-bottom: 24px;\n}\n\n.hero-cta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  margin-bottom: 32px;\n}\n\n.hero-metrics {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 18px;\n}\n\n.metric {\n  font-size: 1.9rem;\n  font-weight: 600;\n  color: var(--text);\n}\n\n.hero-media {\n  position: relative;\n  display: flex;\n  justify-content: center;\n}\n\n.device-frame {\n  background: var(--surface);\n  border-radius: 32px;\n  padding: 24px;\n  width: 100%;\n  max-width: 500px;\n  margin: 0 auto;\n  position: relative;\n  box-shadow: var(--shadow);\n  transform: translateY(30px);\n  opacity: 0;\n  transition: transform 600ms ease, opacity 600ms ease;\n}\n\n.device-img {\n  border-radius: 24px;\n}\n\n.floating-card {\n  position: absolute;\n  right: -30px;\n  bottom: 20px;\n  background: rgba(5, 3, 4, 0.9);\n  border-radius: var(--radius);\n  padding: 16px 18px;\n  width: 240px;\n  box-shadow: var(--shadow);\n}\n\n.floating-card.secondary {\n  top: 20px;\n  left: -30px;\n  right: auto;\n}\n\n.card-title {\n  font-weight: 600;\n  margin-bottom: 6px;\n}\n\n.card-body {\n  color: var(--muted);\n  font-size: 0.9rem;\n}\n\n.partners {\n  padding-top: 100px;\n  padding-bottom: 50px;\n  border-top: 1px solid rgba(255, 255, 255, 0.05);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.05);\noverflow: hidden;\n}\n\n.marquee {\n  text-align: center;\n  color: var(--muted);\n}\n\n\n.logo-marquee {\n  margin-top: 32px;\n  overflow: hidden;\n  position: relative;\n  width: 100vw;\n  margin-left: calc(-50vw + 50%);\n}\n\n.logo-marquee > div {\n  display: flex;\n  gap: 24px;\n  width: fit-content;\n  animation: scroll-left 40s linear infinite;\n}\n\n.logo-row {\n  display: flex;\n  gap: 100px;\n  padding-right: 100px;\n  flex-shrink: 0;\n}\n\n@keyframes scroll-left {\n  0% {\n    transform: translateX(0);\n  }\n  100% {\n    transform: translateX(calc(-50% - 12px));\n  }\n}\n\n.compliance-logo {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 16px 22px;\n  border-radius: var(--radius);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  background: rgba(255, 255, 255, 0.03);\n  color: var(--text);\n}\n\n.compliance-logo img {\n  height: 42px;\n  object-fit: contain;\n  opacity: 0.95;\n}\n\n.compliance-logo span {\n  font-weight: 600;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  font-size: 0.8rem;\n  color: var(--muted);\n}\n\n.how {\n  padding: 100px 0;\n}\n\n.two-col {\n  display: grid;\n  grid-template-columns: 220px 1fr;\n  gap: 32px;\n}\n\n.how-content {\n  display: grid;\n  gap: 24px;\n}\n\n.how article {\n  background: var(--surface);\n  padding: 24px;\n  border-radius: var(--radius);\n  border: 1px solid rgba(255, 255, 255, 0.05);\n}\n\n.features {\n  padding: 100px 0;\n  background: rgba(255, 255, 255, 0.02);\n}\n\n.section-heading {\n  margin-bottom: 48px;\n  max-width: 720px;\n}\n\n.section-heading h2 {\n  font-family: var(--font-display);\n  font-size: clamp(2rem, 4vw, 3rem);\n  line-height: 1.2;\n}\n\n.feature-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));\n  gap: 24px;\n}\n\n.feature-grid article {\n  background: var(--surface);\n  padding: 24px;\n  border-radius: var(--radius);\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  border: 1px solid rgba(255, 255, 255, 0.05);\n  transform: translateY(30px);\n  opacity: 0;\n  transition: transform 500ms ease, opacity 500ms ease;\n}\n\n.feature-grid article.in-view,\n.device-frame.in-view {\n  transform: translateY(0);\n  opacity: 1;\n}\n\n.feature-grid img {\n  border-radius: 12px;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.tag {\n  display: inline-flex;\n  align-self: flex-start;\n  font-size: 0.78rem;\n  text-transform: uppercase;\n  letter-spacing: 0.2em;\n  padding: 6px 14px;\n  border-radius: 999px;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  color: var(--muted);\n}\n\n.collab {\n  padding: 90px 0;\n}\n\n.collab-inner {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 32px;\n  background: var(--surface);\n  border-radius: var(--radius);\n  padding: 40px;\n  border: 1px solid rgba(255, 255, 255, 0.05);\n}\n\n.pill-group {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n}\n\n.pill {\n  padding: 10px 16px;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.08);\n  border: 1px solid rgba(255, 255, 255, 0.05);\n  font-size: 0.9rem;\n}\n\n.testimonials {\n  padding: 100px 0;\n}\n\n.testimonial-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));\n  gap: 24px;\n}\n\n.testimonial-grid article {\n  background: var(--surface);\n  padding: 28px;\n  border-radius: var(--radius);\n  border: 1px solid rgba(255, 255, 255, 0.05);\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.testimonial-grid strong {\n  display: block;\n  font-size: 1rem;\n}\n\n.testimonial-grid span {\n  color: var(--muted);\n  font-size: 0.9rem;\n}\n\n.pricing {\n  padding: 100px 0;\n  background: rgba(255, 255, 255, 0.02);\n}\n\n.pricing-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 48px;\n  align-items: stretch;\n}\n\n.pricing-intro h2 {\n  margin-bottom: 16px;\n}\n\n.pricing-lede {\n  color: var(--muted);\n  font-size: 1.1rem;\n  margin-bottom: 32px;\n}\n\n.pricing-perks {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));\n  gap: 16px;\n}\n\n.pricing-perks div {\n  background: var(--surface);\n  border-radius: var(--radius);\n  border: 1px solid rgba(255, 255, 255, 0.06);\n  padding: 18px;\n}\n\n.pricing-perks p {\n  color: var(--muted);\n  margin-top: 6px;\n}\n\n.pricing-card {\n  background: linear-gradient(140deg, rgba(255, 107, 44, 0.18), rgba(5, 3, 4, 0.8));\n  border-radius: calc(var(--radius) + 4px);\n  padding: 40px;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  box-shadow: 0 25px 60px rgba(0, 0, 0, 0.35);\n}\n\n.pricing-badge {\n  align-self: flex-start;\n  background: rgba(5, 3, 4, 0.5);\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  padding: 6px 14px;\n  border-radius: 999px;\n  font-size: 0.85rem;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n}\n\n.pricing-price {\n  display: flex;\n  align-items: baseline;\n  gap: 10px;\n}\n\n.pricing-price span:first-child {\n  font-size: clamp(3rem, 6vw, 3.8rem);\n  font-family: var(--font-display);\n  font-weight: 600;\n}\n\n.pricing-price span:last-child {\n  color: var(--muted);\n  font-size: 1rem;\n}\n\n.pricing-card > p {\n  color: var(--muted);\n}\n\n.pricing-features {\n  list-style: none;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin: 0;\n  padding: 0;\n}\n\n.pricing-features li {\n  position: relative;\n  padding-left: 28px;\n  color: var(--text);\n}\n\n.pricing-features li::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 8px;\n  width: 14px;\n  height: 14px;\n  border-radius: 4px;\n  background: var(--accent);\n  box-shadow: 0 0 10px rgba(255, 107, 44, 0.5);\n}\n\n.pricing-card .primary-btn {\n  width: 100%;\n  text-align: center;\n}\n\n.pricing-note {\n  color: var(--muted);\n  font-size: 0.95rem;\n  text-align: center;\n}\n\n.faq {\n  padding: 100px 0 120px;\n}\n\n.faq-list {\n  display: grid;\n  gap: 16px;\n}\n\n.faq-item {\n  border-radius: var(--radius);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  background: var(--surface);\n}\n\n.faq-item button {\n  width: 100%;\n  background: none;\n  border: none;\n  color: var(--text);\n  font-size: 1.1rem;\n  padding: 20px 24px;\n  text-align: left;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  cursor: pointer;\n}\n\n.faq-item span {\n  width: 16px;\n  height: 16px;\n  position: relative;\n  display: inline-block;\n}\n\n.faq-item span::before,\n.faq-item span::after {\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background: var(--text);\n}\n\n.faq-item span::before {\n  width: 12px;\n  height: 2px;\n}\n\n.faq-item span::after {\n  width: 2px;\n  height: 12px;\n}\n\n.faq-item button[aria-expanded=\"true\"] span::after {\n  opacity: 0;\n}\n\n.faq-content {\n  max-height: 0;\n  overflow: hidden;\n  padding: 0 24px;\n  color: var(--muted);\n  opacity: 0;\n  transition: max-height 300ms ease, padding 300ms ease, opacity 300ms ease;\n}\n\n.faq-item.open .faq-content {\n  max-height: 320px;\n  padding: 12px 24px 20px;\n  opacity: 1;\n}\n\n.cta {\n  padding: 100px 0;\n  background: radial-gradient(circle at top, rgba(255, 107, 44, 0.3), transparent);\n}\n\n.cta-inner {\n  background: var(--surface);\n  border-radius: var(--radius);\n  padding: 48px;\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 32px;\n  border: 1px solid rgba(255, 255, 255, 0.05);\n}\n\n.title-h1{\n  line-height: 1.1;\n}\n\n.cta-downloads {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 16px;\n}\n\n.store-card {\n  flex: 1 1 240px;\n  min-width: 220px;\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  padding: 18px 26px;\n  border-radius: 26px;\n  background: #fff;\n  color: #111;\n  box-shadow: 0 12px 25px rgba(0, 0, 0, 0.2);\n  transition: transform 200ms ease, box-shadow 200ms ease;\n  height: fit-content;\n  max-height: fit-content;\n}\n\n.store-card:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 18px 30px rgba(0, 0, 0, 0.25);\n}\n\n.store-icon {\n  width: 48px;\n  height: 48px;\n  border-radius: 16px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(0, 0, 0, 0.05);\n  color: #111;\n}\n\n.store-icon svg {\n  width: 26px;\n  height: 26px;\n  fill: currentColor;\n}\n\n.store-copy {\n  display: flex;\n  flex-direction: column;\n  line-height: 1.1;\n}\n\n.store-label {\n  font-size: 0.9rem;\n  color: #555;\n}\n\n.store-name {\n  font-size: 1.35rem;\n  font-weight: 600;\n}\n\n.store-apple .store-icon {\n  background: #111;\n  color: #fff;\n}\n\n.store-play .store-icon {\n  background: #111;\n  color: #0f9d58;\n}\n\n.store-windows .store-icon {\n  background: #e3f0ff;\n  color: #0078d4;\n}\n\n.store-macos .store-icon {\n  background: #f0ecff;\n  color: #5337ff;\n}\n\n.cta-form {\n  display: grid;\n  gap: 16px;\n}\n\n.cta-form input {\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  border-radius: 999px;\n  padding: 14px 20px;\n  background: rgba(5, 3, 4, 0.6);\n  color: var(--text);\n  font-size: 1rem;\n}\n\n.site-footer {\n  padding: 80px 0 60px;\n  border-top: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.footer-top {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 48px;\n  justify-content: space-between;\n  align-items: flex-start;\n}\n\n.footer-brand {\n  max-width: 320px;\n}\n\n.brand-footer img {\n  height: 32px;\n}\n\n.footer-brand p {\n  margin-top: 16px;\n  color: var(--muted);\n}\n\n.footer-links-grid {\n  flex: 1;\n  min-width: 320px;\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n  gap: 32px 48px;\n}\n\n.footer-column p {\n  font-weight: 600;\n  margin-bottom: 16px;\n}\n\n.footer-column > a {\n  display: block;\n  margin-bottom: 10px;\n  color: var(--muted);\n  transition: color 200ms ease;\n}\n\n.footer-column > a:hover {\n  color: var(--text);\n}\n\n.footer-socials {\n  display: flex;\n  gap: 12px;\n  justify-content: flex-start;\n}\n\n.social-btn {\n  width: 44px;\n  height: 44px;\n  border-radius: 14px;\n  background: rgba(255, 255, 255, 0.08);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: transform 200ms ease, background 200ms ease;\n}\n\n.social-btn svg {\n  width: 20px;\n  height: 20px;\n  fill: #fff;\n}\n\n.social-btn:hover {\n  transform: translateY(-2px);\n  background: rgba(255, 255, 255, 0.15);\n}\n\n.footer-divider {\n  height: 1px;\n  background: rgba(255, 255, 255, 0.1);\n  margin: 48px 0 28px;\n}\n\n.footer-bottom {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n}\n\n.footer-copy {\n  color: var(--muted);\n}\n\n.footer-legal {\n  display: flex;\n  gap: 24px;\n  color: var(--muted);\n}\n\n.footer-legal a:hover {\n  color: var(--text);\n}\n\n@media (max-width: 900px) {\n  .desktop-nav {\n    display: none;\n  }\n\n  .nav-toggle {\n    display: block;\n  }\n\n  .nav-cta .text-link {\n    display: none;\n  }\n\n  .two-col {\n    grid-template-columns: 1fr;\n  }\n\n  .hero-metrics {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .hero-grid {\n    flex-direction: column;\n    text-align: center;\n    align-items: center;\n  }\n\n  .hero-copy {\n    align-items: center;\n  }\n\n  .hero-media {\n    justify-content: center;\n  }\n}\n\n@media (max-width: 640px) {\n  .hero-metrics {\n    grid-template-columns: 1fr;\n  }\n\n  .cta-inner {\n    padding: 32px;\n  }\n\n  .cta-downloads {\n    flex-direction: column;\n  }\n\n  .nav-container {\n    padding: 18px 0;\n  }\n\n  .footer-links-grid {\n    grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));\n  }\n\n  .footer-bottom {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .footer-legal {\n    flex-wrap: wrap;\n    gap: 12px;\n  }\n\n  .hero {\n    padding: 90px 0 40px;\n    height: auto;\n  }\n\n  .hero-grid {\n    gap: 32px;\n  }\n\n  .hero-copy {\n    text-align: center;\n    gap: 24px;\n  }\n\n  .hero-cta {\n    justify-content: center;\n  }\n\n  .hero-media {\n    width: 100%;\n  }\n\n  .device-frame {\n    max-width: 360px;\n    padding: 18px;\n  }\n\n  .logo-marquee {\n    width: 100%;\n    margin-left: 0;\n  }\n\n  .logo-row {\n    gap: 32px;\n    padding-right: 32px;\n  }\n\n  .collab-inner,\n  .section-heading,\n  .pricing-intro,\n  .pricing-card,\n  .cta-inner,\n  .testimonial-grid article {\n    text-align: center;\n  }\n\n  .pill-group {\n    justify-content: center;\n  }\n\n  .cta-downloads {\n    width: 100%;\n  }\n\n  .store-card {\n    width: 100%;\n    justify-content: center;\n  }\n\n  .footer-top {\n    flex-direction: column;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
